
import { defineComponent } from "vue";

import Template from "@/components/Templates/Kozhencherry.vue";
import News from "@/components/News/Template2/index.vue";
import { NEWS_ROUTE_NAMES } from "@/ts/enum";

export default defineComponent({
  name: NEWS_ROUTE_NAMES.NEWS_POYANIL_KOZHENCHERRY,
  components: {
    News,
    Template,
  },
});
